export default "__VITE_ASSET__DyIzEeOd__"